import { styled } from "../../../../../../../../theme/default/styled";

export const SBankSelectContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
`;
